import React from 'react'
import { HintTooltip } from '../common/hint-tooltip'
import { cn } from '@/lib/utils'
import { TextIllegalIcon } from './assets/text-illegal-icon'
import { useTranslation } from 'react-i18next'
import { ConfirmModal } from '../common/confirm-modal'

interface ScriptIllegalButtonProps {
  openScriptIllegal: boolean,
  setOpenScriptIllegal: (v: boolean) => void,
  showRiskTipsModal: boolean,
  setShowRiskTipsModal: (v: boolean) => void,
  onContinue: () => void,
  onCancel: () => void,
}

/** 脚本违禁词检测按钮 */
export const ScriptIllegalButton: React.FC<ScriptIllegalButtonProps> = ({
  openScriptIllegal,
  setOpenScriptIllegal,
  showRiskTipsModal,
  setShowRiskTipsModal,
  onContinue,
  onCancel,
}) => {
  const { t } = useTranslation()
  return (
    <div>
      <HintTooltip
        text={t('illegal_word.tips')}
        trigger={
          <button
            type="button"
            aria-label="违禁词检测"
            className="size-9 flex items-center justify-center rounded-[8px] hover:bg-[rgba(242,244,247,1)] transition-colors flex-shrink-0 cursor-pointer text-[rgba(16,24,40,1)] outline-none"
            onClick={() => setOpenScriptIllegal(!openScriptIllegal)}
          >
            <TextIllegalIcon className={cn("size-5", openScriptIllegal && "text-[rgba(117,66,247,1)]")} />
          </button>
        }
      />
      {showRiskTipsModal && (
        <ConfirmModal
          open={showRiskTipsModal}
          title={t('illegal_word.modal.title')}
          description={t('illegal_word.modal.desc')}
          cancel={t('illegal_word.modal.generate')}
          confirm={t('illegal_word.modal.edit')}
          onCancel={onContinue}
          onConfirm={onCancel}
          onOpenChange={setShowRiskTipsModal}
        />
      )}
    </div>
  )
}
